import React from 'react';
import PropTypes from 'prop-types';
import SwiperWrapper from '../common/swiper_wrapper';
// import { propTypes as rowPropTypes } from './row';
import VideoCard from '../card/video_card';
import getUniqueKeyForCard from '../../utils/getUniqueKeyForCard';
import { onHomepage } from '../../utils/dom';
import { MEDIA_QUERIES } from '../common/media_query';
import {map} from 'lodash';

const SLIDER_PROPS = {
  slidesPerView: 4,
  slidesPerGroup: 4,
  freeMode: false,
  simulateTouch: false,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true
  },
  breakpoints: {
    /*
     * Tablet
     */
    [MEDIA_QUERIES.tablet.maxWidth]: {
      slidesPerView: 'auto',
      simulateTouch: true,
      slidesPerGroup: 2,
      freeMode: true
    },
    /*
     * Mobile
     */
    [MEDIA_QUERIES.mobile.maxWidth]: {
      slidesPerView: 'auto',
      simulateTouch: true,
      slidesPerGroup: 1,
      freeMode: true
    }
  }
};

const FlexVideoRow = ({
  cards,
  dataAttributes,
  type,
  isHomepageRefresh
}, {
  isPreviewPage,
  location,
  edition_data
}) => {
  const videoCards = map(cards, (card) => {
    const key = getUniqueKeyForCard(card, isPreviewPage);
    const label = card.series_name || card.label;
    const cardProps = {
      ...card,
      key,
      rowType: type,
      label
    };
    return <div key={key}><VideoCard {...cardProps} /></div>;
  });

  const title = onHomepage(location, edition_data) ? 'Trending Videos' : 'Just Released';

  return (
    <div className="row flex-video" {...dataAttributes} >
      {!isHomepageRefresh && <h2 className="flex-video-title">{title}</h2>}
      <div className="flex-video-content">
        <SwiperWrapper sliderProps={SLIDER_PROPS}>
          {videoCards}
        </SwiperWrapper>
      </div>
    </div>
  );
};

// FlexVideoRow.propTypes = Object.assign({ ...rowPropTypes }, {
//   dataAttributes: PropTypes.object.isRequired,
//   isHomepageRefresh: PropTypes.bool
// });

FlexVideoRow.defaultProps = {
  dataAttributes: {}
};

FlexVideoRow.contextTypes = {
  isPreviewPage: PropTypes.bool.isRequired,
  location: PropTypes.object,
  edition_data: PropTypes.object
};

export default FlexVideoRow;
